import { useEffect } from 'react';

import { buriedPoint } from '@lcsc-ui/utils/buriedPoint';
import dynamic from 'next/dynamic';

import Banner from '@/features/banner/index';
import ProductList from '@/features/productList/index';

const DynamicComputePrice = dynamic(() => import('@/features/computePrice/pages/index'), { ssr: false });
const DynamicTechnology = dynamic(() => import('@/features/technology/index'), {
  ssr: false,
});
const DynamicDetailList = dynamic(() => import('@/features/detailList/index'), {
  ssr: false,
});
const DynamicVideoList = dynamic(() => import('@/features/videoList/index'), {
  ssr: false,
});
const DynamicAboutJLC = dynamic(() => import('@/features/aboutJLC/index'), {
  ssr: false,
});

const SmtPage = () => {
  useEffect(() => {
    const sid = setTimeout(() => {
      buriedPoint({
        pf: 'pc',
        ty: 'enter',
        cp: 'industry',
        op: 'arrive_industry',
      });
    }, 1000);
    // 清除事件监听器
    return () => {
      clearTimeout(sid);
    };
  }, []);
  return (
    <>
      {/* banner图 */}
      <Banner />
      {/* 计价部分 */}
      <DynamicComputePrice />
      {/* 商品部分 */}
      <ProductList />
      {/* 工艺能力 */}
      <DynamicTechnology />
      {/* 详情展示手风琴 */}
      <DynamicDetailList />
      {/* 视频列表 */}
      <DynamicVideoList />
      {/* 关于嘉立创 */}
      <DynamicAboutJLC />
    </>
  );
};

export default SmtPage;
